function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

import React from 'react';
import PropTypes from 'prop-types';
import { SyncLoader } from 'react-spinners';
import 'scss/cndc_prices.scss';
import { initializePlot } from './helpers';
import { Blur, SpinnerBox, PlotContainer } from './style';

var LinePlot =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LinePlot, _React$Component);

  function LinePlot() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LinePlot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LinePlot)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.shouldComponentUpdate = function (nextProps) {
      if (_this.props.loading !== nextProps.loading) return true;
      if (_this.props.windowWidth !== nextProps.windowWidth) return true;
      if (_this.props.checkboxState !== nextProps.checkboxState) return true;
      return false;
    };

    _this.render = function () {
      var range = initializePlot(_this.props.data, _this.props, _assertThisInitialized(_assertThisInitialized(_this)));

      if (range) {
        _this.props.actions.setTotalDateRange(_this.props.countryID, _this.props.plotID, range.total);

        _this.props.actions.updateDateRange(_this.props.countryID, _this.props.plotID, range.update);
      }

      return range ? React.createElement("div", {
        className: "col-sm-12 col-md-12"
      }, React.createElement(PlotContainer, {
        id: _this.props.plotID,
        className: "data-page__section__graph data-page__section__graph--prices"
      }), React.createElement(Blur, {
        visible: _this.props.loading,
        height: '480'
      }, React.createElement(SpinnerBox, null, React.createElement(SyncLoader, {
        color: "#e9eded"
      })))) : React.createElement("div", null, React.createElement(PlotContainer, {
        id: _this.props.plotID,
        className: "data-page__section__graph data-page__section__graph--prices"
      }), React.createElement(Blur, {
        visible: _this.props.loading,
        height: '480'
      }));
    };

    return _this;
  }

  _createClass(LinePlot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      initializePlot(this.props.data, this.props, this);
    }
  }]);

  return LinePlot;
}(React.Component);

export { LinePlot as default };
LinePlot.propTypes = {
  plotID: PropTypes.string,
  loading: PropTypes.bool,
  countryID: PropTypes.string,
  actions: PropTypes.object,
  windowWidth: PropTypes.number,
  checkboxState: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};